import React from 'react';

export const initialState = {
  updates: 0,
  rates: {
    month: { active: 0, dueToday: 0, delayed: 0, completed: 0, grand: 0 },
    lastMonth: { active: 0, dueToday: 0, delayed: 0, completed: 0, grand: 0 },
    custom: { active: 0, dueToday: 0, delayed: 0, completed: 0, grand: 0 },
  },
  categories: {
    selected: { value: 'alltasks', label: 'All Tasks' },
    options: [
      { value: 'alltasks', label: 'All Tasks' },
      { value: 'mytasks', label: 'My Tasks' },
    ],
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_PROCESSES_RATES':
      return {
        ...state,
        rates: {
          ...state.rates,
          [action.rate]: action.counts,
        },
      };

    case 'UPDATE_PROCESSES_RATES_UPDATES':
      return {
        ...state,
        updates: state.updates + 1,
      };

    case 'UPDATE_PROCESSES_CATEGORIES':
      return {
        ...state,
        categories: {
          ...state.categories,
          options: action.categories,
        },
      };

    case 'UPDATE_PROCESSES_SELECTED_CATEGORY':
      return {
        ...state,
        categories: {
          ...state.categories,
          selected: action.selected,
        },
      };

    default:
      return state;
  }
}
